import InternalAdminLayout from '@/layouts/InternalAdminLayout/InternalAdminLayout';

export default InternalAdminLayout;
